import Home from './Home.data-manager-vertical.vue'

export default {Home}
